import { css } from "@emotion/react";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { FC } from "react";

import { OrderType } from "~/components/database/detail/database-content/lib";

type OrderIconProps = {
  orderType: OrderType;
};

export const OrderIcon: FC<OrderIconProps> = ({ orderType }) => {
  if (orderType === "none") {
    return (
      <span css={orderNoneIconStyle} aria-hidden={true}>
        <ArrowDropDown fontSize="small" />
        <ArrowDropUp fontSize="small" />
      </span>
    );
  }

  const Icon = orderType === "asc" ? ArrowDropDown : ArrowDropUp;
  return <Icon css={orderIconStyle} />;
};

const orderNoneIconStyle = css`
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  vertical-align: top;
  color: #7a7a7a;

  & > * {
    position: absolute;

    &:first-of-type {
      transform: translateY(4px);
    }

    &:last-child {
      transform: translateY(-4px);
    }
  }
`;

const orderIconStyle = css`
  vertical-align: top;
`;
